import AppVersionInfoService from "./AppVersionInfoService";
import AppVersionInfoApiRouteService from "./AppVersionInfoApiRouteService";

class HandheldPinkAppVersionInfoService extends AppVersionInfoService {
    constructor(apiClient) {
        super(apiClient, new AppVersionInfoApiRouteService("handheld-pink-app-version"));
    }
}

export default HandheldPinkAppVersionInfoService;
